import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

export default class extends Controller {
    static values = {
        placeholderText: String,
        allowDeselect: Boolean,
        searchText: String,
        searchPlaceholder: String,
        noItemsFound: String
    }

    connect() {
        this.slimSelect = new SlimSelect({
            select: this.element,
            settings: {
                placeholderText: this.placeholderTextValue,
                allowDeselect: this.allowDeselectValue,
                searchText: this.searchTextValue || 'Search',
                searchPlaceholder: this.searchPlaceholderValue || 'Search',
                searchHighlight: true,
                closeOnSelect: true
            },
            events: {
                searchFilter: (option, search) => {
                    return option.text.toLowerCase().indexOf(search.toLowerCase()) !== -1
                }
            }
        })

        // Override SlimSelect's default messages with localized ones
        if (this.noItemsFoundValue) {
            // Find and replace "No items found" text in the SlimSelect dropdown
            setTimeout(() => {
                const noResultsElement = this.element.parentNode.querySelector('.ss-content .ss-search .ss-addable');
                if (noResultsElement && noResultsElement.textContent.includes('No items found')) {
                    noResultsElement.textContent = this.noItemsFoundValue;
                }
            }, 100);
        }
    }

    disconnect() {
        this.slimSelect.destroy();
    }
}
